import React, { useState } from "react";
import Chats from "components/Messages/components/Chats/Chats";
import MessagesReportContainer from "components/Messages/components/ReportContainer/MessagesReportContainer";
import "../../components/Messages/styles.scss";
import Chat from "components/Messages/components/Chat/Chat";
import { chatDataType } from "components/Messages/types";

const Messages = () => {
  const [isReportContainerOpen, setIsReportContainerOpen] = useState(false);
  const [selectedChat, setSelectedChat] = useState<chatDataType | null>(null);

  return (
    <div className="messagesContainer">
      <Chats
        isReportContainerOpen={isReportContainerOpen}
        setIsOpen={setIsReportContainerOpen}
        setSelectedChat={setSelectedChat}
        selectedChat={selectedChat}
      />
      <Chat
        isReportContainerOpen={isReportContainerOpen}
        setIsOpen={setIsReportContainerOpen}
        selectedChat={selectedChat}
      />
      {isReportContainerOpen && (
        <MessagesReportContainer setIsOpen={setIsReportContainerOpen} />
      )}
    </div>
  );
};

export default Messages;
